"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGenerator = exports.update = exports.hasGenerator = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var namespace = 'dive-simulation-manager-generator-manager';
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var obj = {
        generator: null,
        generator_exit: null,
        generatorPauseSeconds: 0,
    };
    return obj;
}
function hasGenerator() {
    return !!get().generator;
}
exports.hasGenerator = hasGenerator;
function update() {
    var obj = get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.generatorPauseSeconds > 0) {
        obj.generatorPauseSeconds -= ds;
        return;
    }
    if (obj.generator) {
        var generatorResult = obj.generator.next();
        if (generatorResult.done) {
            console.log(namespace, 'generator is done!');
            obj.generator = null;
            exitCurrentMode(false);
        }
        else {
            obj.generatorPauseSeconds = generatorResult.value;
        }
    }
}
exports.update = update;
function addGenerator(generator, generatorExit) {
    if (generatorExit === void 0) { generatorExit = function () { }; }
    console.log(namespace, 'adding generator');
    var obj = get();
    exitCurrentMode(true);
    obj.generator = generator;
    obj.generator_exit = generatorExit;
}
exports.addGenerator = addGenerator;
function exitCurrentMode(isCancelled) {
    var obj = get();
    console.log(namespace, 'exiting generator', isCancelled);
    if (obj.generator_exit) {
        obj.generator_exit(isCancelled);
        obj.generator_exit = null;
    }
}
